/**
 * Spinner — atom (ADR-0007). Lucide loader-2 + animate-spin.
 */
import { Icon } from '@/components/icons/Icon'

const sizeMap = { sm: 14, md: 16, lg: 24 } as const
const toneMap = {
  brand: 'text-accent-brand-primary',
  onBrand: 'text-text-on-brand',
  muted: 'text-text-muted',
  current: '',
} as const

export function Spinner({
  size = 'md',
  tone = 'current',
  label = 'Загрузка',
  className = '',
}: {
  size?: keyof typeof sizeMap
  tone?: keyof typeof toneMap
  label?: string
  className?: string
}) {
  return (
    <span role="status" aria-label={label} className={`inline-flex items-center justify-center ${toneMap[tone]} ${className}`}>
      <Icon name="loader-2" size={sizeMap[size]} aria-hidden="true" className="animate-spin" />
    </span>
  )
}
